import { COP_SITE_DETAILS_ACCESSIBILITY } from '../constants/copSiteDetails.constants'

// ─── Hierarchy (factory/building) icon ───────────────────────────────────────

export const HierarchyIcon = () => (
    <div className="icon-btn" role="img" aria-label={COP_SITE_DETAILS_ACCESSIBILITY.FACTORY_ARIA_LABEL}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 21h18v-2h-2V3H9v4H5v12H3zm8-16h6v14h-2v-2h-2v2h-2V5zM7 9h2v2H7V9zm0 4h2v2H7v-2zm0 4h2v2H7v-2z" />
        </svg>
    </div>
)

// ─── Warning (triangle exclamation) icon ─────────────────────────────────────

export const WarningIcon = () => (
    <div className="icon-btn icon-btn--warning" role="img" aria-label={COP_SITE_DETAILS_ACCESSIBILITY.WARNING_ARIA_LABEL}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
        </svg>
    </div>
)

// ─── Chevron (dropdown arrow) icon ───────────────────────────────────────────

export const ChevronIcon = ({ open }: { open: boolean }) => (
    <svg
        className={`cop-data-grid__filter-chevron${open ? ' cop-data-grid__filter-chevron--open' : ''}`}
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
